import React from "react";
import classNames from "classnames";
import NoDataFoundSvg from 'assets/icons/NoDataFound.svg';

const NoDataFound = (props?:any) => {
    return <div className={classNames(`w-full flex flex-col justify-center items-center ${!!props?.className ? props?.className : ""}`)}>
    <img className={"w-1/5 h-1/5"} src={NoDataFoundSvg} />
    <p className="font-bold text-center text-md">No Data Found !</p>
  </div>;
}
 
export default NoDataFound;